import { installNativeWebViewLifecycleHandlers } from './nativeWebViewLifecycle';
import { patchGetLocationGlobalIfAbsent } from './patchGetLocationGlobalIfAbsent';

let initialized = false;

/**
 * Idempotent bootstrap for WKWebView / managed-browser geolocation integration.
 * Installs `window.getLocation` early and registers page-teardown handlers so native
 * bridge traffic stops before the web view is deallocated.
 */
export function initializeNativeGeolocationHost(): void {
  if (initialized || globalThis.window === undefined) {
    return;
  }

  initialized = true;
  patchGetLocationGlobalIfAbsent();
  installNativeWebViewLifecycleHandlers();
}
